module.exports = __webpack_public_path__ + "img/apply.2411d117.svg";